<template>
	<div class="my-3">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form">
				<b-row>
					<b-col md="8" cols="12">
						<b-form-group label="Total Rental Income (Monthly)">
							<b-input-group v-if="isForeigIncome" size="md" prepend="RM">
								<b-form-input v-model="formattedTotalOtherIncome" type="text" disabled></b-form-input>
							</b-input-group>

							<b-form-input v-else v-model="formattedTotalOtherIncome" type="text"
								placeholder="Enter Total Rental Income (Monthly)" disabled></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>

				<el-table :data="rentals" style="width: 100%" cell-class-name="px-3">
					<el-table-column label="No." width="50" align="center">
						<template slot-scope="scope">{{ scope.$index + 1 }}</template>
					</el-table-column>
					<el-table-column label="Rental Income Amount" min-width="200">
						<template slot-scope="scope">
							<CurrencyInput v-model="scope.row.amount" :options="currencyOptions" />
						</template>
					</el-table-column>
					<el-table-column label="Postal Code" min-width="120">
						<template slot-scope="scope">
							<ValidationProvider v-slot="{ errors }" :rules="{ postcode: true }" :vid="'postcode'">
								<b-form-input v-model="scope.row.postcode" @keydown="_gHlp.checkNonNumericInput" type="text"
									maxlength="5"></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</template>
					</el-table-column>
					<el-table-column label="Housing Type" min-width="200">
						<template slot-scope="scope">
							<el-select v-model="scope.row.housing_type_id" placeholder="Select">
								<el-option v-for="housingType in tables.housing_types" :key="housingType.housing_type_id"
									:label="housingType.type" :value="housingType.housing_type_id">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="Project Name" min-width="250">
						<template slot-scope="scope">
							<el-input v-model="scope.row.project_name"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Actions" min-width="100">
						<template slot-scope="scope">
							<svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeRental(scope.row)"
								class="text-danger cursor-pointer mx-2" width="20" height="20" viewBox="0 0 512 512">
								<path fill="currentColor"
									d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512zm-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
							</svg>
						</template>
					</el-table-column>
				</el-table>
				<b-button @click="addRental" block variant="outline-primary" class="mt-3">+ Add</b-button>
				<!-- <b-row class="mt-4">
                    <b-col cols="4">
                        <b-button block variant="primary" @click.prevent="update()" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row> -->
			</b-form>
		</ValidationObserver>
	</div>
</template>

<script>
import { Button, Form, FormItem, Table, TableColumn, Select, Option } from 'element-ui'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	props: ['customer', 'tables', 'main_form'],
	components: {
		CurrencyInput,
		ValidationObserver,
		ValidationProvider,
		[Button.name]: Button,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin,
	],
	data() {
		return {
			rentals: [],
			// isCurrencyConverted: false
		}
	},
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
		totalOtherIncome() {
			const total = this.rentals.reduce((acc, rental) => {
				const amount = parseFloat(rental.amount);
				return isNaN(amount) ? acc : acc + amount;
			}, 0);
			return total;
		},
		formattedTotalOtherIncome: {
			get() {
				return isNaN(this.totalOtherIncome) ? '0.00' : this.totalOtherIncome.toFixed(2);
			},
			set(newValue) {
			}
		},
		currencyOptions() {
			return {
				currency: 'MYR',
				currencyDisplay: this.isForeigIncome ? 'symbol' : 'hidden',
				autoDecimalDigits: true,
			};
		},
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	watch: {
		customer: {
			handler: function (newValue) {
				if (!_gHlp.isEmpty(newValue)) {
					this.initData();
				}
			},
			immediate: true
		},
		main_form: {
			handler: function (newValue) {
				if (!_gHlp.isEmpty(newValue)) {
					this.initData();
				}
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		initData() {
			this.rentals = _gHlp.getValue(this.customer, 'incomes.rental', []);
			// if(this.isForeigIncome && !this.isCurrencyConverted){
			// 	this.rentals.forEach(el => {
			// 		el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate)
			// 	});
			// 	this.isCurrencyConverted = true;
			// }
		},
		setData() {
			let rentals = this.rentals.map((obj, index) => {
				return {
					...(obj.customer_rental_income_id && { customer_rental_income_id: obj.customer_rental_income_id }),
					// amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount,
					amount: obj.amount,
					postcode: obj.postcode,
					housing_type_id: obj.housing_type_id,
					project_name: obj.project_name,
				}
			})

			let data = { rentals: rentals }
			return data;
		},
		update() {
			let data = this.setData()
			axios.post(services.customer + 'customer/' + this.customer.customer_id + '/income/rentals', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Monthly Rental Income: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.customer.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		removeRental(item) {
			if (this.rentals.length > 0) {
				var index = this.rentals.indexOf(item);
				this.rentals.splice(index, 1);
			}
		},
		addRental() {
			this.rentals.push({
				amount: null,
				postcode: null,
				housing_type_id: null,
				project_name: null,
			});
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		}
	}
}
</script>